"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preFormat = exports.formatText = exports.formatList = exports.format = void 0;
var _plateCodeBlock = require("@udecode/plate-code-block");
var _plateCommon = require("@udecode/plate-common");
var _plateList = require("@udecode/plate-list");
var preFormat = function preFormat(editor) {
  return (0, _plateList.unwrapList)(editor);
};
exports.preFormat = preFormat;
var format = function format(editor, customFormatting) {
  if (editor.selection) {
    var parentEntry = (0, _plateCommon.getParentNode)(editor, editor.selection);
    if (!parentEntry) return;
    var _parentEntry = _slicedToArray(parentEntry, 1),
      node = _parentEntry[0];
    if ((0, _plateCommon.isElement)(node) && !(0, _plateCommon.isType)(editor, node, _plateCodeBlock.ELEMENT_CODE_BLOCK) && !(0, _plateCommon.isType)(editor, node, _plateCodeBlock.ELEMENT_CODE_LINE)) {
      customFormatting();
    }
  }
};
exports.format = format;
var formatList = function formatList(editor, elementType) {
  format(editor, function () {
    return (0, _plateList.toggleList)(editor, {
      type: elementType
    });
  });
};
exports.formatList = formatList;
var formatText = function formatText(editor, text) {
  format(editor, function () {
    return editor.insertText(text);
  });
};
exports.formatText = formatText;